import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvv7f3bnra: FaireProductEntity = {
  token: "p_bvv7f3bnra",
  type: "product",
  name: "Extra Virgin Olive Oil",
  brandToken: "b_tx8dz6jy5e",
  brandName: "Oolio",
  imageUrl:
    "https://cdn.faire.com/fastly/35cca7756dc033c6c124db9329e09ba3d8af671e4198379f8658c53084e782a2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0790ae72f2a75fec42fa7fc706fb1763ffd4ae30e4214daef5abb053b532446f.png",
    "https://cdn.faire.com/fastly/509c34d6cfce2d34fb9b31f1729ee886ef1864e0b94d75911fef34a20122a2e3.png",
  ],
  priceDollars: 16.5,
  description:
    "100% Organic \n\nNutty, buttery and with just a little peppery sass at the end. Handpicked from family-owned groves under the golden Sicilian sun in Italy. \n\nCold-extracted right after harvest to keep all that bold, fresh flavor locked in with 462 ± mg/kg of polyphenol. The kind of olive oil you’ll want to pour on everything. \n\n500ML.\n\n#PRE-ORDER FOR 25/26 HARVEST AND GET OUR EARLY BATCH! ",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:28.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
